import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import NoIndexSEO from "../../../components/SEO/NoIndexSEO";
import { Col, Row, Card, Form } from "react-bootstrap";
import { seoConfig } from "../../../utils/seoConfig";
import * as Chart from "chart.js";
import Select from "react-select";
import { getRetirementCal } from "../../../redux/slices/retirementCalSlice";
import { ReactComponent as FiSliders } from "../../../assets/images/filters-icon.svg";
import debounce from "lodash.debounce";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import {
  getinvestmentReports,
  getinvestmentReportsInputs,
} from "../../../redux/slices/investmentSlice";
import { useForm } from "react-hook-form";
import { Line } from "react-chartjs-2";
import {
  getAllCities,
  getAllStates,
  getRoles,
} from "../../../redux/slices/profileSlice";

import { components } from "react-select";
import { allowedNames, allowedRolesForFree } from "../../../constants";
import { useNavigate } from "react-router-dom";
import ComparisonModal from "../../restriction-modals/ComparisonModal";
import {
  activityEnd,
  activityStart,
} from "../../../redux/slices/trackActivitySlice";
import usePageTracking from "../../../hooks/usePageTracking";
import { calculatorAnalytics } from "../../../redux/slices/lifeinsuranceSlice";
import { useTheme } from "../../../context/ThemeContext";
import { sessionId } from "../../../redux/slices/cityComparisonSlice";

const RetirementCalculator = ({ selectedCities }) => {
  const { resolvedTheme } = useTheme();
  const isDarkMode = resolvedTheme === "dark";
  const [currentAge, setCurrentAge] = useState(30);
  const [retirementAge, setRetirementAge] = useState(65);
  const [currentSavings, setCurrentSavings] = useState(0);
  const [monthlyContribution, setMonthlyContribution] = useState(950);
  const [annualReturn, setAnnualReturn] = useState(7);
  const [inflationRate, setInflationRate] = useState(2.5);
  const [desiredIncome, setDesiredIncome] = useState(60000);
  const [lifeExpectancy, setLifeExpectancy] = useState(90);
  const [graphData, setGraphData] = useState([]);
  const [activeIndex, setActiveIndex] = useState();
  const [stateOptions, setStateOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [roleOptions, setRoleOptions] = useState([]);
  const [selectedState, setSelectedState] = useState();
  const [selectedRole, setSelectedRole] = useState();
  const [selectedCity, setSelectedCity] = useState();
  const analyticsDebounceRef = useRef({});
  const [localCities, setLocalCities] = useState({
    current: { state: null, city: null },
    destination: { state: null, city: null },
  });

  // const handleRoleChange = (selectedOption) => {
  //   setSelectedRole(selectedOption?.value || null);
  // };

  const handleStateChange = (selectedOption) => {
    setSelectedState(selectedOption?.code || null);
  };

  const handleCityChange = (selectedOption) => {
    setSelectedCity(selectedOption?.value || null);
  };

  useEffect(() => {
    setLocalCities(
      selectedCities || {
        current: { state: null, city: null },
        destination: { state: null, city: null },
      },
    );
  }, [selectedCities]);

  //   const store = useSelector((state) => state.auth);
  const [subAlertCompModalVisible, setSubAlertCompModalVisible] = useState(
    false,
  );

  const store = useSelector((state) => state.profile);
  const authStore = useSelector((state) => state.auth);
  //   const investmentFieldSchema = Yup.object().shape({
  //     salary: Yup.number()
  //       .typeError("Salary must be a number")
  //       .positive("Salary must be positive")
  //       .required("Salary is required"),

  //     contribution_rate: Yup.number()
  //       .typeError("Contribution rate must be a number")
  //       .min(1, "Contribution rate should be between 1 and 100")
  //       .max(100, "Contribution rate should be between 1 and 100")
  //       .required("Contribution rate is required"),

  //     current_age: Yup.number()
  //       .typeError("Current age must be a number")
  //       .min(20, "Age must be more than 20 years old")
  //       .required("Current age is required"),

  //     retirement_age: Yup.number()
  //       .typeError("Retirement age must be a number")
  //       .max(65, '"Retirement age" must be less than or equal to 65')
  //       .when("current_age", (current_age, schema) => {
  //         if (current_age) {
  //           return schema
  //             .moreThan(
  //               current_age,
  //               "Retirement Age should be more than Current Age"
  //             )
  //             .min(40, '"Retirement age" must be greater than or equal to 40');
  //         }
  //         return schema.min(
  //           40,
  //           '"Retirement age" must be greater than or equal to 40'
  //         );
  //       })
  //       .required("Retirement age is required"),

  //     rate_of_return: Yup.number()
  //       .typeError("Rate of return must be a number")
  //       .min(5, "Return rate must be between 5 and 15")
  //       .max(15, "Return rate must be between 5 and 15")
  //       .required("Rate of return is required"),
  //   });

  const toNumber = (value) =>
    isNaN(value) || value === "" ? undefined : Number(value);

  const investmentFieldSchema = Yup.object().shape({
    salary: Yup.number()
      .transform(toNumber)
      .positive("Salary must be positive")
      .required("Salary is required"),

    contribution_rate: Yup.number()
      .transform(toNumber)
      .min(1, "Contribution rate should be between 1 and 100")
      .max(100, "Contribution rate should be between 1 and 100")
      .required("Contribution rate is required"),

    current_age: Yup.number()
      .transform(toNumber)
      .min(20, "Age must be more than 20")
      .required("Current age is required"),

    retirement_age: Yup.number()
      .transform(toNumber)
      .max(65, "Retirement age must be ≤ 65")
      .when("current_age", (currentAge, schema) =>
        currentAge
          ? schema.moreThan(
              currentAge,
              "Retirement age must be greater than current age",
            )
          : schema,
      )
      .min(40, "Retirement age must be ≥ 40")
      .required("Retirement age is required"),

    rate_of_return: Yup.number()
      .transform(toNumber)
      .min(5, "Return rate must be between 5 and 15")
      .max(15, "Return rate must be between 5 and 15")
      .required("Rate of return is required"),
  });

  const [calculatedResults, setCalculatedResults] = useState([]);
  const [summery, setSummery] = useState({});
  const [showFilters, setShowFilters] = useState(false);
  const [subText, setSubText] = useState({
    header: "",
    desc: "",
    massage1: "",
    pluspricem: "",
    pluspricey: "",
    desc2: "",
    promassage: "",
    propricem: "",
    propricey: "",
  });

  // 1. New Error State Object
  const [retirementErrors, setRetirementErrors] = useState({});

  const chartRef = useRef(null);
  const chartRegisterRef = useRef(null);
  const chartInstance = useRef(null);
  const [upgradeSource, setUpgradeSource] = useState("");
  const investmentDataStore = useSelector((state) => state.investment);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const validateInputs = useCallback(() => {
    let newErrors = {};
    let isValid = true;

    // Rule: Age 18 to 100
    if (currentAge < 18 || currentAge > 100) {
      newErrors.currentAge = "Current age must be between 18 and 100.";
      isValid = false;
    }

    // Rule: Retirement Age Logic
    if (retirementAge > 65) {
      newErrors.retirementAge = "Retirement age must be 65 or less.";
      isValid = false;
    } else if (retirementAge <= 40) {
      newErrors.retirementAge = "Retirement age must be greater than 40.";
      isValid = false;
    } else if (currentAge >= retirementAge) {
      newErrors.retirementAge =
        "Retirement age must be greater than current age.";
      isValid = false;
    }

    // Rule: Life Expectancy Logic
    if (lifeExpectancy > 100) {
      newErrors.lifeExpectancy = "Life expectancy cannot exceed 100.";
      isValid = false;
    } else if (lifeExpectancy <= currentAge) {
      newErrors.lifeExpectancy =
        "Life expectancy must be greater than current age.";
      isValid = false;
    } else if (lifeExpectancy <= retirementAge) {
      newErrors.lifeExpectancy =
        "Life expectancy must be greater than retirement age.";
      isValid = false;
    }

    setRetirementErrors(newErrors);
    return isValid;
  }, [currentAge, retirementAge, lifeExpectancy]);

  const fetchRetirementData = useCallback(async () => {
    const formData = {
      current_age: currentAge,
      retirement_age: retirementAge,
      current_savings: currentSavings,
      monthly_contribution: monthlyContribution,
      annual_return_rate: annualReturn,
      inflation_rate: inflationRate,
      life_expectancy: lifeExpectancy,
      desired_income: desiredIncome,
      page: 1,
      length: 150,
    };

    try {
      if (formData.annual_return_rate <= 20 && formData.inflation_rate <= 15) {
        // ⏳ 1 second delay
        await new Promise((resolve) => setTimeout(resolve, 1000));

        const response = await dispatch(getRetirementCal(formData));

        if (response.payload?.data) {
          setCalculatedResults(response.payload.data.docs);
          setSummery(response.payload.data.full_summary);

          const session_id = sessionStorage.getItem("comparison_session_id");

          if (session_id) {
            dispatch(
              calculatorAnalytics({
                calculator_type: "retirement_usa",
                event_type: "retirement_calculator_view",
                session_id,
                timestamp: new Date().toISOString(),
              }),
            );
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
  }, [
    currentAge,
    retirementAge,
    currentSavings,
    monthlyContribution,
    annualReturn,
    inflationRate,
    lifeExpectancy,
    desiredIncome,
    dispatch,
  ]);
  // const fetchRetirementData = useCallback(async () => {
  //   const formData = {
  //     current_age: currentAge,
  //     retirement_age: retirementAge,
  //     current_savings: currentSavings,
  //     monthly_contribution: monthlyContribution,
  //     annual_return_rate: annualReturn,
  //     inflation_rate: inflationRate,
  //     life_expectancy: lifeExpectancy,
  //     desired_income: desiredIncome,
  //     page: 1,
  //     length: 150,
  //   };

  //   try {
  //     if (formData.annual_return_rate <= 20 && formData.inflation_rate <= 15) {
  //       const response = await dispatch(getRetirementCal(formData));

  //       if (response.payload?.data) {
  //         setCalculatedResults(response.payload.data.docs);
  //         setSummery(response.payload.data.full_summary);

  //         const session_id =
  //           sessionStorage.getItem("comparison_session_id");

  //         if (session_id) {
  //           dispatch(
  //             calculatorAnalytics({
  //               calculator_type: "retirement_usa",
  //               event_type: "retirement_calculator_view",
  //               session_id,
  //               timestamp: new Date().toISOString(),
  //             })
  //           );
  //         }
  //       }
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }, [
  //   currentAge,
  //   retirementAge,
  //   currentSavings,
  //   monthlyContribution,
  //   annualReturn,
  //   inflationRate,
  //   lifeExpectancy,
  //   desiredIncome,
  //   dispatch,
  // ]);
  usePageTracking("RETIREMENT_CALCULATOR");
  useEffect(() => {
    const payload = {
      page_name: "RETIREMENT_CALCULATOR",
      platform: "web",
    };

    dispatch(activityStart(payload));
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch(
        activityEnd({
          page_name: "RETIREMENT_CALCULATOR",
        }),
      );
    };
  }, [dispatch]);


  

  useEffect(() => {
    if (selectedRole && selectedState && selectedCity) {
      const payload = {
        role: selectedRole,
        state: selectedState,
        city: selectedCity,
      };
      dispatch(getinvestmentReportsInputs(payload));
    }
  }, [selectedRole, selectedState, selectedCity, dispatch]);

  const inputsData = investmentDataStore?.investmentReportInputs;

  useEffect(() => {
    if (localCities?.destination?.state?.code) {
      dispatch(
        getAllCities({
          search_state: localCities.destination.state.code,
        }),
      );
    }
  }, [dispatch, localCities?.destination?.state?.code]);

  useEffect(() => {
    if (store?.stateItems?.data?.states?.length) {
      const options = store?.stateItems?.data?.states?.map((state) => ({
        value: state?.id,
        label: state?.state_full_name || state.state,
        code: state?.state,
      }));
      setStateOptions(options);
    }

    if (store?.cityItems?.data) {
      const options = store?.cityItems?.data?.cities?.map((cityObj) => ({
        value: cityObj?.city,
        label: cityObj?.city,
      }));
      setCityOptions(options);
    }

    if (store?.roleItems?.data) {
      // const planName = store?.profileItem?.data?.plan?.name;
      const planName = authStore?.user?.plan?.name
        ? authStore?.user?.plan?.name
        : store?.profileItem?.data?.plan?.name;
      const data = store?.roleItems?.data?.describe_roles?.map((s) => {
        const roleName = s.name;
        let isDisabled = false;
        let requiredPlan = "";

        if (planName === "Free") {
          if (!allowedRolesForFree.includes(roleName)) {
            isDisabled = true;
            requiredPlan = "Pro";
          }
        }

        return {
          value: s.id,
          label: isDisabled ? `${roleName} (${requiredPlan})` : roleName,
          isDisabled,
          requiredPlan,
        };
      });

      setRoleOptions(data);
    }
  }, [
    store?.stateItems?.data,
    store?.cityItems?.data,
    store?.roleItems?.data,
    store?.profileItem,
    authStore?.user?.plan?.name,
  ]);

  // 3. Effect that handles Validation AND Fetching
  useEffect(() => {
    // Only fetch if validation passes
    if (validateInputs()) {
      fetchRetirementData();
    }
    // If validation fails, validateInputs() sets the error state automatically,
    // and we strictly do NOT call fetchRetirementData.
  }, [validateInputs, fetchRetirementData]);

  // Chart Effect
  useEffect(() => {
    if (
      chartRegisterRef.current &&
      calculatedResults &&
      calculatedResults.length > 0
    ) {
      const data = calculatedResults;
      const labels = data.map((d) => d.age);
      const balances = data.map((d) => Math.floor(d.projected_balance));

      if (chartInstance.current) {
        chartInstance.current.destroy();
      }

      const ctx = chartRegisterRef.current.getContext("2d");
      chartInstance.current = new Chart.Chart(ctx, {
        type: "line",
        data: {
          labels: labels,
          datasets: [
            {
              label: "Balance",
              data: balances,
              borderColor: isDarkMode ? "#38b6f1" : "rgb(1, 149, 211)",
              backgroundColor: "rgba(75, 192, 192, 0.2)",
              tension: 0.3,
              fill: true,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: "top",
              labels: { color: isDarkMode ? "#9aa7ac" : "#656e74" },
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  return "$" + context.parsed.y.toLocaleString();
                },
              },
            },
          },
          scales: {
            y: {
              beginAtZero: true,
              title: {
                display: true,
                text: "Savings Balance ($)",
                color: isDarkMode ? "#9aa7ac" : "#656e74",
              },
              ticks: {
                color: isDarkMode ? "#9aa7ac" : "#656e74",
                callback: (value) => {
                  if (value >= 1000000000) {
                    return (
                      "$" +
                      (value / 1000000000).toFixed(1).replace(/\.0$/, "") +
                      "B"
                    );
                  } else if (value >= 1000000) {
                    return (
                      "$" +
                      (value / 1000000).toFixed(1).replace(/\.0$/, "") +
                      "M"
                    );
                  } else if (value >= 1000) {
                    return "$" + (value / 1000).toFixed(0) + "K";
                  }
                  return "$" + value;
                },
              },
              grid: {
                color: isDarkMode
                  ? "rgba(255, 255, 255, 0.08)"
                  : "rgba(0, 0, 0, 0.05)",
              },
            },
            x: {
              title: {
                display: true,
                text: "Age (Years)",
                color: isDarkMode ? "#9aa7ac" : "#656e74",
              },
              ticks: {
                color: isDarkMode ? "#9aa7ac" : "#656e74",
              },
              grid: {
                color: isDarkMode
                  ? "rgba(255, 255, 255, 0.08)"
                  : "rgba(0, 0, 0, 0.05)",
              },
            },
          },
        },
      });
    }

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [calculatedResults, isDarkMode]);

  const formatCurrency = (value) => {
    if (value === undefined || value === null) return "$0";
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  };

  useEffect(() => {
    dispatch(getRoles());
    dispatch(getAllStates());
  }, [dispatch]);

  useEffect(() => {
    if (selectedState) {
      dispatch(getAllCities({ search_state: selectedState }));
    }
  }, [dispatch, selectedState]);

  const formatNumber = (number) => {
    const parsedNumber = parseInt(number);
    if (isNaN(parsedNumber)) return "$0";

    const formattedNumber = new Intl.NumberFormat().format(
      Math.abs(parsedNumber),
    );

    return parsedNumber < 0 ? `-$${formattedNumber}` : `$${formattedNumber}`;
  };

  const resultsData = [
    {
      label: "Years to Retirement",
      value: (summery.years_to_retirement || 0) + " years",
    },
    {
      label: "Future Value (current savings)",
      value: formatCurrency(summery.future_savings),
    },
    {
      label: "Future Value (contributions)",
      value: formatCurrency(summery.future_contributions),
    },
    {
      label: "Total Savings at " + retirementAge,
      value: formatCurrency(summery.total_savings),
    },
    {
      label: "Inflation‑Adjusted Income Needed",
      value: formatCurrency(summery.adjusted_income),
    },
    {
      label: "Safe Withdrawal (4%)",
      value: formatCurrency(summery.safe_withdrawal),
    },
    {
      label: "Years Covered",
      value: Math.floor(summery.years_covered || 0) + " years",
    },
    { label: "Status", value: summery.status || "Calculating..." },
  ];

  const {
    register,
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(investmentFieldSchema), // Connect Yup schema
    mode: "onChange", // Validate on every change for real-time feedback
    defaultValues: {
      salary: 50000,
      contribution_rate: 10,
      current_age: 20,
      retirement_age: 45,
      rate_of_return: 10,
    },
  });

  const formData = watch();

  const toggleDataset = () => {
    console.log("Toggling dataset visibility");

    const chart = chartRef.current; // chart is already the Chart.js instance
    if (!chart) {
      console.log("No chart instance found");
      return;
    }

    const meta = chart.getDatasetMeta(0);
    meta.hidden = meta.hidden === null ? !chart.isDatasetVisible(0) : null;
    chart.update();
    // console.log("Toggled dataset visibility", chart);
  };
  // const debouncedDispatch = useCallback(
  //   debounce((inputData) => {
  //     dispatch(getinvestmentReports(inputData));
  //   }, 500),
  //   [dispatch]
  // );
  const debouncedDispatch = useMemo(
    () =>
      debounce((inputData) => {
        dispatch(getinvestmentReports(inputData));
      }, 500),
    [dispatch],
  );
  useEffect(() => {
    const data = inputsData?.data;
    if (data && Object.keys(data).length > 0) {
      setValue("salary", data.salary);
      setValue("contribution_rate", data.contribution_rate);
      setCurrentAge(data.start_age);
      setRetirementAge(data.end_age);
      //   setValue("current_age", data.start_age);
      //   setValue("retirement_age", data.end_age);
      setValue("rate_of_return", data.interest_rate);
    }
  }, [dispatch, inputsData, setValue]);
  useEffect(() => {
    const validateAndDispatch = async () => {
      const isValid = await trigger();
      if (!isValid) return;

      const payload = {
        salary: Number(formData.salary),
        contribution_rate: Number(formData.contribution_rate),
        start_age: Number(currentAge),
        end_age: Number(retirementAge),
        interest_rate: Number(formData.rate_of_return),
      };

      if (
        payload.start_age > 20 &&
        payload.end_age >= 40 &&
        payload.end_age <= 65 &&
        payload.interest_rate <= 15 &&
        payload.interest_rate >= 10 &&
        payload.contribution_rate <= 100 &&
        payload.contribution_rate > 1
      ) {
        // ⏳ 1 second delay
        await new Promise((resolve) => setTimeout(resolve, 1000));

        debouncedDispatch(payload);

        // ✅ TRACK ANALYTICS
        const session_id = sessionStorage.getItem("comparison_session_id");

        if (session_id) {
          dispatch(
            calculatorAnalytics({
              calculator_type: "investment",
              event_type: "investment_calculator_view",
              session_id,
              timestamp: new Date().toISOString(),
            }),
          );
        }
      }
    };

    validateAndDispatch();

    return () => {
      debouncedDispatch.cancel();
    };
  }, [
    formData.salary,
    formData.contribution_rate,
    currentAge,
    retirementAge,
    formData.rate_of_return,
    debouncedDispatch,
    trigger,
    dispatch,
  ]);

  //   useEffect(() => {
  //   const validateAndDispatch = async () => {
  //     const isValid = await trigger();
  //     if (!isValid) return;

  //     const payload = {
  //       salary: Number(formData.salary),
  //       contribution_rate: Number(formData.contribution_rate),
  //       start_age: Number(currentAge),
  //       end_age: Number(retirementAge),
  //       interest_rate: Number(formData.rate_of_return),
  //     };

  //     if (
  //       payload.start_age > 20 &&
  //       payload.end_age >= 40 &&
  //       payload.end_age <= 65 &&
  //       payload.interest_rate <= 15 &&
  //       payload.interest_rate >= 10 &&
  //       payload.contribution_rate <= 100 &&
  //       payload.contribution_rate > 1
  //     ) {
  //       debouncedDispatch(payload);

  //       // ✅ TRACK ANALYTICS HERE
  //       const session_id =
  //         sessionStorage.getItem("comparison_session_id");

  //       if (session_id) {
  //         dispatch(
  //           calculatorAnalytics({
  //             calculator_type: "investment",
  //             event_type: "investment_calculator_view",
  //             session_id,
  //             timestamp: new Date().toISOString(),
  //           })
  //         );
  //       }
  //     }
  //   };

  //   validateAndDispatch();

  //   return () => {
  //     debouncedDispatch.cancel();
  //   };
  // }, [
  //   formData.salary,
  //   formData.contribution_rate,
  //   currentAge,
  //   retirementAge,
  //   formData.rate_of_return,
  //   debouncedDispatch,
  //   trigger,
  //   dispatch,
  // ]);

  const investmentData = useMemo(
    () => investmentDataStore?.investmentReport?.data ?? [],
    [investmentDataStore?.investmentReport?.data],
  );

  useEffect(() => {
    setGraphData(
      investmentData.map((item, index) => ({
        value: Number(item?.savings ?? 0),
        label: String(item?.age ?? ""),
        index,
      })),
    );
  }, [investmentData]);

  const chartData = {
    labels: graphData.map((item, index) => {
      return item.label;
    }),
    datasets: [
      {
        label: "Project Balance",
        data: graphData?.map((item, index) => {
          // console.log(item, "Item Of Chart")
          return item?.value;
        }),
        borderColor: isDarkMode ? "#38b6f1" : "#0195D3",
        backgroundColor: isDarkMode ? "#38b6f1" : "#0195D3",
        tension: 0.4,
        pointRadius: 6,
        pointBackgroundColor: isDarkMode ? "#121f26" : "#fff",
        pointBorderColor: isDarkMode ? "#38b6f1" : "#0195D3",
        pointBorderWidth: 1,
        borderWidth: 2,
      },
    ],
  };

  // const CustomRoleOption = (props) => {
  //   const { isDisabled } = props;
  //   console.log(props, "isDisabled");

  //   return (
  //     <div
  //       onClick={(e) => {
  //         if (isDisabled) {
  //           e.stopPropagation(); // Prevents selection
  //           setSubText({
  //             header: "Subscription Required!",
  //             // desc: "Plus or Pro plan is required",
  //             desc: "You need Plus or Pro plan to unlock more Roles",
  //             massage1: "Plus: Unlock 6 Roles ($6.99/mo)",
  //             massage2: "Pro:  Unlock all Roles ($12.99/mo)",
  //             desc2: "You need Pro plan to unlock more Roles",
  //             promassage: "Pro:  Unlock all Roles ($12.99/mo)",
  //           });
  //           setSubAlertModalVisible(true);
  //         }
  //         // For enabled options: do nothing → react-select handles selection normally
  //       }}
  //       style={{
  //         width: "100%",
  //         cursor: isDisabled ? "pointer" : "default",
  //       }}
  //     >
  //       <components.Option {...props} />
  //     </div>
  //   );
  // };
  const CustomRoleOption = (props) => {
    const { isDisabled, data } = props;
    const { requiredPlan } = data;

    return (
      <div
        onClick={(e) => {
          if (isDisabled) {
            e.stopPropagation();
            const source = "nursing_role_limit";

            if (requiredPlan === "Pro") {
              setSubText({
                header: "Subscription Required!",
                desc: "",
                massage1: "",
                massage2: "",
                desc2: "You need a Pro plan to unlock this role",
                promassage: "Upgrade to Pro for full role visibility",
                propricem: "$2.99/month",
                propricey: "$29.99/year",
              });
            }
            setUpgradeSource(source);
            setSubAlertCompModalVisible(true);
          }
        }}
        style={{
          width: "100%",
          cursor: isDisabled ? "pointer" : "default",
        }}
      >
        <components.Option {...props} />
      </div>
    );
  };
  const user = useSelector((state) => state.auth?.user);

  useEffect(() => {
    if (!user) {
      sessionStorage.removeItem("comparison_session_id");
      sessionStorage.removeItem("session_expiry");

      console.log("🧹 Session cleared on logout");
    }
  }, [user]);
  useEffect(() => {
    if (!user?.id) return;

    const existingSession = sessionStorage.getItem("comparison_session_id");
    const expiry = sessionStorage.getItem("session_expiry");

    // 🔥 Check if valid session exists
    if (existingSession && expiry && Date.now() < Number(expiry)) {
      return;
    }

    // const token = localStorage.getItem("authToken");

    // dispatch(
    //   sessionId({
    //     user_id: user.id,
    //     access_token: token,
    //   }),
    dispatch(sessionId()).then((res) => {
      const data = res.payload?.data;

      if (data?.session_id) {
        sessionStorage.setItem("comparison_session_id", data.session_id);

        // 🔥 store expiry (important)
        const expiryTime = Date.now() + data.expires_in * 1000;
        sessionStorage.setItem("session_expiry", expiryTime);
      }
    });
  }, [user]);

  const trackRetirementInput = (inputName, value) => {
    const session_id = sessionStorage.getItem("comparison_session_id");

    // ❌ Stop if no session
    if (!session_id) return;

    // ❌ Stop if empty
    if (value === "" || value === null || value === undefined) return;

    // ❌ Stop if invalid number
    if (isNaN(Number(value))) return;

    // Clear previous debounce
    if (analyticsDebounceRef.current[inputName]) {
      clearTimeout(analyticsDebounceRef.current[inputName]);
    }

    // 2 sec delay
    analyticsDebounceRef.current[inputName] = setTimeout(() => {
      dispatch(
        calculatorAnalytics({
          calculator_type: "retirement_usa",
          event_type: "input_adjusted",
          input_name: inputName,
          inputs: Number(value), // always send number
          results_viewed: true,
          session_id,
          timestamp: new Date().toISOString(),
        }),
      );
    }, 1000);
  };
  const formatSelectValue = (value) => {
    if (!value) return null;

    return String(value)
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "_")
      .replace(/[^\w]/g, "_");
  };
  const trackSelectChange = (inputName, rawValue) => {
    const session_id = sessionStorage.getItem("comparison_session_id");
    if (!session_id || !rawValue) return;

    const formattedValue = formatSelectValue(rawValue);

    if (analyticsDebounceRef.current[inputName]) {
      clearTimeout(analyticsDebounceRef.current[inputName]);
    }

    analyticsDebounceRef.current[inputName] = setTimeout(() => {
      dispatch(
        calculatorAnalytics({
          calculator_type: "retirement_usa",
          event_type: "input_adjusted",
          input_name: inputName,
          inputs: formattedValue,
          results_viewed: true,
          session_id,
          timestamp: new Date().toISOString(),
        }),
      );
    }, 1000); // 1 second debounce
  };
  return (
    <div className="filters-content-main">
      <NoIndexSEO title={seoConfig.RetirementCalculator.title} />

      <Row className="mb-3">
        {/* Sidebar Form */}
        <div className="filter-sidebar">
          <Card className="filter-container mb-0">
            <div className="inner-sub-sub-title">
              <div className="inner-sub-title">USA Retirement Calculator</div>
              <button
                className="filter-toggle-btn"
                onClick={() => setShowFilters(!showFilters)}
              >
                {/* {showFilters ? "Hide Filters" : "Show Filters"} */}
                <FiSliders />
              </button>
            </div>
            <div className={`filter ${showFilters ? "open" : "closed"}`}>
              <form>
                {/* Current Age */}
                <div className="filter-section pb-0">
                  <div className="group-with-error border-0 p-0">
                    <Form.Group className="form-group mb-0">
                      <Form.Label className="col-label">Current Age</Form.Label>
                      <input
                        type="number"
                        placeholder="Current Age"
                        min={18}
                        max={100}
                        value={currentAge}
                        // onChange={(e) => setCurrentAge(Number(e.target.value))}
                        onChange={(e) => {
                          const value = Number(e.target.value);
                          setCurrentAge(value);
                          trackRetirementInput("current_age", value);
                        }}
                        className={`col-input ${
                          retirementErrors.currentAge ? "input-error" : ""
                        }`}
                      />
                    </Form.Group>
                    {/* {retirementErrors.currentAge && <span className="error-text"> {retirementErrors.currentAge}</span>} */}
                    {retirementErrors.currentAge && (
                      <div
                        className="error-message"
                        style={{ display: "flex", justifyContent: "left" }}
                      >
                        {retirementErrors.currentAge}
                      </div>
                    )}
                  </div>
                </div>

                {/* Retirement Age */}
                <div className="filter-section pb-0">
                  <div className="group-with-error border-0 p-0">
                    <Form.Group className="form-group mb-0">
                      <Form.Label className="col-label">
                        Retirement Age
                      </Form.Label>
                      <input
                        type="number"
                        placeholder="Enter Retirement Age"
                        value={retirementAge}
                        // onChange={(e) =>
                        //   setRetirementAge(Number(e.target.value))
                        // }
                        onChange={(e) => {
                          const value = Number(e.target.value);
                          setRetirementAge(value);
                          trackRetirementInput("retirement_age", value);
                        }}
                        className={`col-input ${
                          retirementErrors.retirementAge ? "input-error" : ""
                        }`}
                      />
                    </Form.Group>
                    {/* {retirementErrors.retirementAge && <span className="error-text"> {retirementErrors.retirementAge}</span>} */}
                    {retirementErrors.retirementAge && (
                      <div
                        className="error-message"
                        style={{ display: "flex", justifyContent: "left" }}
                      >
                        {retirementErrors.retirementAge}
                      </div>
                    )}
                  </div>
                </div>

                {/* Current Savings */}
                <div className="filter-section pb-0">
                  <div className="group-with-error border-0 p-0">
                    <Form.Group className="form-group mb-0">
                      <Form.Label className="col-label">
                        Current Savings
                      </Form.Label>
                      <input
                        type="number"
                        placeholder="Enter Current Savings"
                        value={currentSavings}
                        // onChange={(e) =>
                        //   setCurrentSavings(Number(e.target.value))
                        // }
                        onChange={(e) => {
                          const value = Number(e.target.value);
                          setCurrentSavings(value);
                          trackRetirementInput("current_savings", value);
                        }}
                        className="col-input"
                      />
                    </Form.Group>
                  </div>
                </div>

                {/* Monthly Contribution */}
                <div className="filter-section pb-0">
                  <div className="group-with-error border-0 p-0">
                    <Form.Group className="form-group mb-0">
                      <Form.Label className="col-label">
                        Monthly Contribution
                      </Form.Label>
                      <input
                        type="number"
                        placeholder="Enter Monthly Contribution"
                        value={monthlyContribution}
                        // onChange={(e) =>
                        //   setMonthlyContribution(Number(e.target.value))
                        // }
                        onChange={(e) => {
                          const value = Number(e.target.value);
                          setMonthlyContribution(value);
                          trackRetirementInput("monthly_contribution", value);
                        }}
                        className="col-input"
                      />
                    </Form.Group>
                  </div>
                </div>

                {/* Annual Return Rate (%) */}
                <div className="filter-section pb-0">
                  <div className="group-with-error border-0 p-0">
                    <Form.Group className="form-group mb-0">
                      <Form.Label className="col-label">
                        Annual Return Rate (%)
                      </Form.Label>
                      <input
                        type="number"
                        placeholder="Annual Return Rate (%)"
                        value={annualReturn}
                        // onChange={(e) =>
                        //   setAnnualReturn(Number(e.target.value))
                        // }
                        onChange={(e) => {
                          const value = Number(e.target.value);
                          setAnnualReturn(value);
                          trackRetirementInput("annual_return_rate", value);
                        }}
                        className="col-input"
                      />
                    </Form.Group>
                  </div>
                </div>

                {/* Inflation Rate (%) */}
                <div className="filter-section pb-0">
                  <div className="group-with-error border-0 p-0">
                    <Form.Group className="form-group mb-0">
                      <Form.Label className="col-label">
                        Inflation Rate (%)
                      </Form.Label>
                      <input
                        type="number"
                        placeholder="Enter Inflation Rate (%)"
                        value={inflationRate}
                        // onChange={(e) =>
                        //   setInflationRate(Number(e.target.value))
                        // }
                        onChange={(e) => {
                          const value = Number(e.target.value);
                          setInflationRate(value);
                          trackRetirementInput("inflation_rate", value);
                        }}
                        className="col-input"
                      />
                    </Form.Group>
                  </div>
                </div>

                {/* Desired Income (Per Year) */}
                <div className="filter-section pb-0">
                  <div className="group-with-error border-0 p-0">
                    <Form.Group className="form-group mb-0">
                      <Form.Label className="col-label">
                        Desired Income (Per Year)
                      </Form.Label>
                      <input
                        type="number"
                        placeholder="Enter Desired Income (Per Year)"
                        value={desiredIncome}
                        // onChange={(e) =>
                        //   setDesiredIncome(Number(e.target.value))
                        // }
                        onChange={(e) => {
                          const value = Number(e.target.value);
                          setDesiredIncome(value);
                          trackRetirementInput("desired_income", value);
                        }}
                        className="col-input"
                      />
                    </Form.Group>
                  </div>
                </div>

                {/* Life Expectancy */}
                <div className="filter-section pb-0">
                  <div className="group-with-error border-0 p-0">
                    <Form.Group className="form-group mb-0">
                      <Form.Label className="col-label">
                        Life Expectancy
                      </Form.Label>
                      <input
                        type="number"
                        placeholder="Enter Life Expectancy"
                        value={lifeExpectancy}
                        // onChange={(e) =>
                        //   setLifeExpectancy(Number(e.target.value))
                        // }
                        onChange={(e) => {
                          const value = Number(e.target.value);
                          setLifeExpectancy(value);
                          trackRetirementInput("life_expectancy", value);
                        }}
                        className={`col-input ${
                          retirementErrors.lifeExpectancy ? "input-error" : ""
                        }`}
                      />
                    </Form.Group>
                    {/* {retirementErrors.lifeExpectancy && <span className="error-text"> {retirementErrors.lifeExpectancy}</span>} */}
                    {retirementErrors.lifeExpectancy && (
                      <div
                        className="error-message"
                        style={{ display: "flex", justifyContent: "left" }}
                      >
                        {retirementErrors.lifeExpectancy}
                      </div>
                    )}
                  </div>
                </div>

                <div className="filter-section pb-0">
                  <div className="group-with-error border-0 p-0">
                    <Form.Group className="form-group mb-0">
                      <Form.Label className="col-label">
                        Current salary
                      </Form.Label>

                      <input
                        type="number"
                        placeholder="Enter Current salary"
                        // {...register("salary", { valueAsNumber: true })}
                        {...register("salary", {
                          valueAsNumber: true,
                          onChange: (e) => {
                            const value = e.target.value;
                            trackRetirementInput("salary", value);
                          },
                        })}
                        className={`col-input ${
                          errors.salary ? "input-error" : ""
                        }`}
                      />
                    </Form.Group>

                    {errors.salary && (
                      <div
                        className="error-message"
                        style={{ display: "flex", justifyContent: "left" }}
                      >
                        {errors.salary.message}
                      </div>
                    )}
                  </div>
                </div>

                <div className="filter-section pb-0">
                  <div className="group-with-error border-0 p-0">
                    <Form.Group className="form-group mb-0">
                      <Form.Label className="col-label">
                        Contribution rate (%)
                      </Form.Label>

                      <input
                        type="number"
                        placeholder="Enter Contribution rate (%)"
                        // {...register("contribution_rate", {
                        //   valueAsNumber: true,
                        // })}
                        {...register("contribution_rate", {
                          valueAsNumber: true,
                          onChange: (e) => {
                            const value = e.target.value;
                            trackRetirementInput("contribution_rate", value);
                          },
                        })}
                        className={`col-input ${
                          errors.contribution_rate ? "input-error" : ""
                        }`}
                      />
                    </Form.Group>

                    {errors.contribution_rate && (
                      <div
                        className="error-message"
                        style={{ display: "flex", justifyContent: "left" }}
                      >
                        {errors.contribution_rate.message}
                      </div>
                    )}
                  </div>
                </div>

                <div className="filter-section pb-0">
                  <div className="group-with-error border-0 p-0">
                    <Form.Group className="form-group mb-0">
                      <Form.Label className="col-label">
                        Rate of return
                      </Form.Label>

                      <input
                        type="number"
                        placeholder="Enter Rate of return"
                        // {...register("rate_of_return", { valueAsNumber: true })}
                        {...register("rate_of_return", {
                          valueAsNumber: true,
                          onChange: (e) => {
                            const value = e.target.value;
                            trackRetirementInput("rate_of_return", value);
                          },
                        })}
                        className={`col-input ${
                          errors.rate_of_return ? "input-error" : ""
                        }`}
                      />
                    </Form.Group>

                    {errors.rate_of_return && (
                      <div
                        className="error-message"
                        style={{ display: "flex", justifyContent: "left" }}
                      >
                        {errors.rate_of_return.message}
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </Card>
        </div>

        {/* Main Content */}
        <div className="filter-content">
          <Card className="mb-3">
            <Card.Body>
              <div className="inner-sub-sub-title">
                <div className="inner-sub-title">Retirement Balance</div>
              </div>
              <div style={{ height: "400px", position: "relative" }}>
                <canvas ref={chartRegisterRef}></canvas>
              </div>
            </Card.Body>
          </Card>
          <Card className="mb-0">
            <Card.Body>
              <Row>
                {resultsData.map((obj, i) => (
                  <Col key={i} md={6} className="cardDivBox">
                    <div className="formgroup">
                      <Form.Label className="input-label">
                        {obj.label}
                      </Form.Label>
                      <input
                        type="text"
                        readOnly
                        value={obj.value}
                        className="colinput"
                      />
                    </div>
                  </Col>
                ))}
              </Row>
            </Card.Body>
          </Card>
          {/* Projected Savings */}
          <div className="investment-content my-3">
            <div className="investment-card-container">
              <Row>
                <Col md={4} sm={12} className="invest-select-box">
                  <Form.Group className="form-group">
                    <Form.Label className="col-label">Nursing Role</Form.Label>

                    <Select
                      aria-label="Select Role"
                      value={
                        roleOptions.find(
                          (option) => option.value === selectedRole,
                        ) || null
                      }
                      // onChange={(selectedOption) =>
                      //   setSelectedRole(
                      //     selectedOption ? selectedOption.value : "",
                      //   )
                      // }
                      onChange={(selectedOption) => {
                        const value = selectedOption
                          ? selectedOption.label
                          : null;

                        setSelectedRole(
                          selectedOption ? selectedOption.value : "",
                        );

                        if (value) {
                          trackSelectChange("nursing_role", value);
                        }
                      }}
                      menuPosition="fixed"
                      styles={{
                        menu: (base) => ({
                          ...base,
                          borderRadius: "15px",
                          marginTop: "8px",
                          backgroundColor: "var(--mmp-surface)",
                          padding: "6px",
                          zIndex: "1000",
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                        option: (base, state) => ({
                          ...base,
                          borderRadius: "8px",
                          padding: "10px",
                          backgroundColor: state.isFocused ? "var(--mmp-hover-bg)" : "var(--mmp-surface)",
                          color: "var(--mmp-text-primary)",
                          cursor: "pointer",
                          "&:active": {
                            backgroundColor: "var(--mmp-hover-bg)",
                          },
                        }),
                      }}
                      // options={[
                      //   { value: "", label: "All Roles" },
                      //   ...roleOptions,
                      // ]}
                      options={roleOptions}
                      components={{ Option: CustomRoleOption }}
                      isClearable
                      placeholder="All Roles"
                      className="react-select-container"
                      classNamePrefix="react-select"
                    />
                  </Form.Group>
                </Col>
                <Col md={4} className="col-6 invest-select-box">
                  <Form.Group className="form-group">
                    <Form.Label className="col-label">State</Form.Label>
                    <Select
                      placeholder="Select State"
                      className="react-select-container"
                      classNamePrefix="react-select"
                      options={stateOptions}
                      // value={selectedState}
                      // onChange={handleStateChange}
                      onChange={(selectedOption) => {
                        const value = selectedOption?.label;

                        handleStateChange(selectedOption);

                        if (value) {
                          trackSelectChange("state", value);
                        }
                      }}
                      menuPosition="fixed"
                      styles={{
                        menu: (base) => ({
                          ...base,
                          borderRadius: "15px",
                          marginTop: "8px",
                          backgroundColor: "var(--mmp-surface)",
                          padding: "6px",
                          zIndex: "1000",
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                        option: (base, state) => ({
                          ...base,
                          borderRadius: "8px",
                          padding: "10px",
                          backgroundColor: state.isFocused ? "var(--mmp-hover-bg)" : "var(--mmp-surface)",
                          color: "var(--mmp-text-primary)",
                          cursor: "pointer",
                          "&:active": {
                            backgroundColor: "var(--mmp-hover-bg)",
                          },
                        }),
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md={4} className="col-6 invest-select-box">
                  <Form.Group className="form-group">
                    <Form.Label className="col-label">City</Form.Label>
                    <Select
                      placeholder="Select City"
                      className="react-select-container"
                      classNamePrefix="react-select"
                      options={cityOptions}
                      // onChange={handleCityChange}
                      onChange={(selectedOption) => {
                        const value = selectedOption?.label;

                        handleCityChange(selectedOption);

                        if (value) {
                          trackSelectChange("city", value);
                        }
                      }}
                      menuPosition="fixed"
                      styles={{
                        menu: (base) => ({
                          ...base,
                          borderRadius: "15px",
                          marginTop: "8px",
                          backgroundColor: "var(--mmp-surface)",
                          padding: "6px",
                          zIndex: "1000",
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                        option: (base, state) => ({
                          ...base,
                          borderRadius: "8px",
                          padding: "10px",
                          backgroundColor: state.isFocused ? "var(--mmp-hover-bg)" : "var(--mmp-surface)",
                          color: "var(--mmp-text-primary)",
                          cursor: "pointer",
                          "&:active": {
                            backgroundColor: "var(--mmp-hover-bg)",
                          },
                        }),
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Card className="investment-card investment-chart-card">
                <div className="saving-title">Projected Retirement Saving</div>
                {investmentDataStore?.investmentReport?.data &&
                  investmentDataStore.investmentReport.data.length > 0 &&
                  (() => {
                    const lastItem =
                      investmentDataStore.investmentReport.data[
                        investmentDataStore.investmentReport.data.length - 1
                      ];

                    return (
                      <div className="saving-header">
                        <div className="saving-amount">
                          {formatNumber(Math.floor(lastItem.savings))}
                          <span>By age {retirementAge}</span>
                        </div>

                        {/* Custom Legend */}
                        <div className="custom-legend" onClick={toggleDataset}>
                          <span className="legend-color"></span> Project Balance
                        </div>
                      </div>
                    );
                  })()}

                <div
                  style={{
                    position: "relative",
                    minHeight: "250px",
                    width: "100%",
                  }}
                >
                  <Line
                    ref={chartRef}
                    data={chartData}
                    options={{
                      layout: {
                        padding: { top: 10, bottom: 10, left: 10, right: 10 },
                      },
                      elements: {
                        line: { tension: 0.4 },
                        point: { radius: 4 },
                      },
                      interaction: { mode: "nearest", intersect: false },
                      responsive: true,
                      maintainAspectRatio: false,
                      plugins: {
                        legend: { display: false },
                      },
                      onClick: (event, elements) => {
                        if (!elements.length) return;
                        const index = elements[0].index;
                        const clickedPoint = graphData[index];
                        console.log("Clicked index:", index);
                        console.log("Clicked point:", clickedPoint);
                        setActiveIndex(index);
                      },
                      scales: {
                        x: {
                          afterFit: function(axis) {
                            axis.paddingRight = 20; // Add 20px space at the end
                          },
                          ticks: {
                            color: isDarkMode ? "#9aa7ac" : "#656e74",
                          },
                          grid: {
                            display: true,
                            color: isDarkMode
                              ? "rgba(255, 255, 255, 0.08)"
                              : "rgba(0, 0, 0, 0.05)",
                          },
                        },
                        y: {
                          min: 0,
                          max:
                            Math.max(
                              ...graphData.map((d) => parseFloat(d.value)),
                            ) * 1.02,
                          ticks: {
                            color: isDarkMode ? "#9aa7ac" : "#656e74",
                            stepSize:
                              Math.max(...graphData.map((d) => d.value)) / 7, // 9 ticks total (0 + 8 steps)
                            callback: function(value) {
                              if (value >= 1000000000) {
                                return (
                                  "$" +
                                  (value / 1000000000)
                                    .toFixed(1)
                                    .replace(/\.0$/, "") +
                                  "B"
                                );
                              } else if (value >= 1000000) {
                                return (
                                  "$" +
                                  (value / 1000000)
                                    .toFixed(1)
                                    .replace(/\.0$/, "") +
                                  "M"
                                );
                              } else if (value >= 1000) {
                                return "$" + (value / 1000).toFixed(0) + "K";
                              }
                              return "$" + value;
                            },
                          },
                          grid: {
                            display: true,
                            color: isDarkMode
                              ? "rgba(255, 255, 255, 0.08)"
                              : "rgba(0, 0, 0, 0.05)",
                          },
                        },
                      },
                    }}
                  />
                </div>
              </Card>

              <Card className="investment-stats mb-0">
                {/* Stats Row */}
                {investmentDataStore?.investmentReport?.data &&
                  investmentDataStore.investmentReport.data.length > 0 &&
                  (() => {
                    const lastItem =
                      investmentDataStore.investmentReport.data[activeIndex] ||
                      investmentDataStore.investmentReport.data[
                        investmentDataStore.investmentReport.data.length - 1
                      ];

                    return (
                      <Row className="text-center">
                        <Col className="col-4">
                          <div className="investment-stats-wrapper">
                            <div className="stat-label">
                              Monthly <br />
                              Contribution
                            </div>
                            <div className="stat-value">
                              {formatNumber(
                                Math.floor(lastItem.monthly_contribution),
                              )}
                            </div>
                          </div>
                        </Col>

                        <Col className="col-4">
                          <div className="investment-stats-wrapper">
                            <div className="stat-label">
                              Total <br />
                              Contribution
                            </div>
                            <div className="stat-value">
                              {formatNumber(
                                Math.floor(lastItem.total_contributions),
                              )}
                            </div>
                          </div>
                        </Col>

                        <Col className="col-4">
                          <div className="investment-stats-wrapper">
                            <div className="stat-label">
                              Investment <br />
                              Growth
                            </div>
                            <div className="stat-value">
                              {formatNumber(
                                Math.floor(lastItem.investment_growth),
                              )}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    );
                  })()}
              </Card>

              <Card className="investment-table-card pt-0">
                {/* Table */}

                <div className="investment-table">
                  {/* Header */}
                  <div className="table-header">
                    <div className="col text-center">Years</div>
                    <div className="col text-center">Amount</div>
                  </div>

                  {/* Rows */}
                  {investmentDataStore.investmentReport.data?.map((row, i) => (
                    <div className="table-row" key={i}>
                      <div className="col text-center">{row.age}</div>
                      <div className="col text-center">
                        {formatNumber(Math.floor(row.savings))}
                      </div>
                    </div>
                  ))}
                </div>
              </Card>
              {/* <ActionModal
                title={subText?.header}
                description={subText.desc}
                massage1={subText.massage1}
                pluspricem={subText.pluspricem}
                pluspricey={subText.pluspricey}
                prodesc={subText.desc2}
                promassage={subText.promassage}
                propricem={subText.propricem}
                propricey={subText.propricey}
                isVisible={subAlertModalVisible}
                onClose={() => {
                  setSubAlertModalVisible(false);
                }}
                onPressYes={() => {
                  // Navigate to subscription page or handle upgrade
                  navigate("/profile/subscription");
                  setSubAlertModalVisible(false);
                }}
                yesText="Upgrade Now"
                noText="Cancel"
                // extraData={isRestrictedData}
                extraMetaInfo={true}
              /> */}
              <ComparisonModal
                title={subText?.header}
                description={subText.desc}
                massage1={subText.massage1}
                pluspricem={subText.pluspricem}
                pluspricey={subText.pluspricey}
                prodesc={subText.desc2}
                promassage={subText.promassage}
                propricem={subText.propricem}
                propricey={subText.propricey}
                isVisible={subAlertCompModalVisible}
                eventSource={upgradeSource}
                onClose={() => {
                  setSubAlertCompModalVisible(false);
                }}
                onPressYes={() => {
                  // Navigate to subscription page or handle upgrade
                  // navigate("/profile/subscription", {
                  //   state: { source: upgradeSource },
                  // });
                  setSubAlertCompModalVisible(false);
                }}
                yesText="Upgrade Now"
                noText="Cancel"
                // extraData={isRestrictedData}
                extraMetaInfo={true}
              />
            </div>
          </div>
        </div>
      </Row>
    </div>
  );
};

export default RetirementCalculator;
